import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";

import { backendUrl } from "shared/utils/environment";

import ApplicationState from "store/ApplicationState";

const DjangoLink = ({
  route = "",
  title = "Django Access",
  removeAdminKey = false,
}: {
  route?: string;
  title?: string;
  removeAdminKey?: boolean;
}) => {
  const isAdmin = useSelector(
    ({ auth }: ApplicationState) => auth.user?.is_superuser
  );

  const djangoUrl = `${backendUrl(!!removeAdminKey)}${route}`;

  return isAdmin ? (
    <a href={djangoUrl} title={title} target="_blank" rel="noreferrer">
      <FontAwesomeIcon icon="cogs" />
    </a>
  ) : null;
};

export default DjangoLink;
